export const CREATE_REGISTRATION_FORM_REQUEST = 'CREATE_REGISTRATION_FORM_REQUEST';
export const CREATE_REGISTRATION_FORM_SUCCESS = 'CREATE_REGISTRATION_FORM_SUCCESS';
export const CREATE_REGISTRATION_FORM_FAILED = 'CREATE_REGISTRATION_FORM_FAILED';
